import { useMutation } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { RegistrationSchema } from './schema'
import { getData, postData } from '../../../apis/api.helpers'
import apiUrl from '../../../apis/api.url'
import { parseQueryParams } from '../../../utilities/parsers'
import { useQuery } from '@tanstack/react-query'
const buildUrlWithParams = (baseUrl: string) => {
  return `${baseUrl}${parseQueryParams()}`
}

export const useRegister = (onSuccessCallback: (data: any) => void) => {
  const { enqueueSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: (data: RegistrationSchema) =>
      postData(apiUrl.CREATE_GRIEVANCE, data),

    onSuccess: (response: any) => {
      if (response?.status) {
        enqueueSnackbar(response?.message || 'Registration successful', {
          variant: 'success',
        })
        onSuccessCallback(response)
      } else {
        enqueueSnackbar(response?.message || 'Registration failed', {
          variant: 'error',
        })
      }
    },

    onError: (error: any) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Something went wrong'

      enqueueSnackbar(message, { variant: 'error' })
    },
  })
}
const fetchDistrict = async () => {
  const url = buildUrlWithParams(apiUrl.DISTRICT_LIST)
  const response = await getData(url)
  return response
}
export const useDistrictList = () => {
  return useQuery(['district_listing'], () => fetchDistrict(), {
    refetchOnWindowFocus: false,
  })
}
